/* eslint-disable react/prop-types */
import {
  Typography,
  Stack,
  Button,
  useMediaQuery,
  SwipeableDrawer,
  Box,
  IconButton,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import event_cancel from "../../../../assets/icons/preveiw_cancel.svg";
import { useAuthContext } from "src/auth/useAuthContext";
import updateEventShow from "src/services/events/updateEventShow";

const ShowInList = ({ open, handleClose, eventId, eventData, getData }) => {
  const navigate = useNavigate();
  const { isEdit, handle } = useParams();
  const { user, vendor, logout } = useAuthContext();

  const [showInList, setShowInList] = useState(
    eventData?.show_in_list ? "show" : "hide"
  );

  const handleChoice = async () => {
    await updateEventShow(vendor, user, showInList === "show", eventId, logout);
    getData(user, handle, logout);
    handleClose();
    if (isEdit) {
      navigate("/events");
    }
  };
  const matches = useMediaQuery("(max-width:600px)");
  return (
    <>
      {matches ? (
        <SwipeableDrawer anchor="bottom" open={open} onClose={handleClose}>
          <Stack spacing={2} p="0.5rem 1.5rem" maxHeight="400px">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography fontSize="14px" color="primary" variant="subtitle2">
                List your event on TicketsQue page
              </Typography>
              <IconButton onClick={handleClose}>
                <Box
                  width="100%"
                  maxWidth="30px"
                  component="img"
                  src={event_cancel}
                />
              </IconButton>
            </Stack>
            {/* <DialogTitle id="alert-dialog-title" color={"primary"}>
        
      </DialogTitle> */}

            <Stack spacing={1}>
              <Typography>
                Expand Your Event&apos;s Reach! List your event alongside others
                on our website to reach a broader audience.
              </Typography>
              <Typography>
                Prefer to keep your event private? You can sell your tickets
                privately through the generated link.
              </Typography>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={showInList}
                  onChange={(e) => setShowInList(e.target.value)}
                  name="radio-buttons-group"
                >
                  <Stack
                    direction={{ xs: "column", sm: "row " }}
                    justifyContent="space-between"
                    gap={0}
                  >
                    <FormControlLabel
                      value="show"
                      control={<Radio />}
                      label="I choose to list my event"
                    />
                    <FormControlLabel
                      value="hide"
                      control={<Radio />}
                      label="I want to keep my event private"
                    />
                  </Stack>
                </RadioGroup>
              </FormControl>
            </Stack>

            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Button variant="outlined" onClick={handleClose} size="medium">
                Cancel
              </Button>
              <Button variant="contained" onClick={handleChoice} size="medium">
                Confirm
              </Button>
            </Stack>
          </Stack>
        </SwipeableDrawer>
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" color={"primary"}>
            List your event on TicketsQue page
          </DialogTitle>
          <DialogContent>
            <Stack spacing={1}>
              <Typography>
                Expand Your Event&apos;s Reach! List your event alongside others
                on our website to reach a broader audience.
              </Typography>
              <Typography>
                Prefer to keep your event private? You can sell your tickets
                privately through the generated link.
              </Typography>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={showInList}
                  onChange={(e) => setShowInList(e.target.value)}
                  name="radio-buttons-group"
                >
                  <Stack direction="row" justifyContent="space-between" gap={4}>
                    <FormControlLabel
                      value="show"
                      control={<Radio />}
                      label="I choose to list my event"
                    />
                    <FormControlLabel
                      value="hide"
                      control={<Radio />}
                      label="I want to keep my event private"
                    />
                  </Stack>
                </RadioGroup>
              </FormControl>
            </Stack>
          </DialogContent>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            sx={{ pb: 3, px: 3 }}
          >
            <Button variant="outlined" onClick={handleClose} size="medium">
              Cancel
            </Button>
            <Button variant="contained" onClick={handleChoice} size="medium">
              Confirm
            </Button>
          </Stack>
        </Dialog>
      )}
    </>
  );
};

export default ShowInList;
